module.exports = __webpack_public_path__ + "img/galery-inge-v9-2-zoom.d95cbb73.jpg";